import { ArrowRight } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger
} from '@repo/ui/components/sheet';
import { track } from '@/lib/analytics';

export function MethodologySheet() {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          type="button"
          className="text-rowa-label-md text-rowa-text-brand inline-flex items-center gap-1 font-medium hover:opacity-80"
          onClick={() => track('portfolio.methodology_opened')}
        >
          View methodology <ArrowRight className="size-3.5" aria-hidden />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Performance methodology</SheetTitle>
          <SheetDescription>
            How ROWA calculates the return figures on this page.
          </SheetDescription>
        </SheetHeader>
        <div className="text-rowa-body-sm text-rowa-text-secondary space-y-4 px-4 pb-6">
          <section>
            <h3 className="text-rowa-body-md text-rowa-text-primary font-semibold">
              Return adjusted for deposits and withdrawals
            </h3>
            <p className="mt-1">
              The portfolio line is a time weighted return: deposits and
              withdrawals are netted out of each daily return, so moving money
              in or out never reads as performance. The chart shows the growth
              of $100 from the first day shown for the selected period. A break
              in the line marks a day the return could not be worked out.
            </p>
          </section>
          <section>
            <h3 className="text-rowa-body-md text-rowa-text-primary font-semibold">
              Benchmark overlay
            </h3>
            <p className="mt-1">
              Each benchmark joins your line on the first day where both have a
              value, so the lines are directly comparable from there. On days a
              benchmark does not trade, its last close carries forward. The US
              dollar benchmark is the price of the UUP fund, which follows the
              dollar against six major currencies. It is a fund, not the dollar
              index itself, so the two can drift apart.
            </p>
          </section>
          <section>
            <h3 className="text-rowa-body-md text-rowa-text-primary font-semibold">
              Returns by period
            </h3>
            <p className="mt-1">
              Each period row uses the same adjusted return over its own window.
              The benchmark column measures the benchmark over the same days:
              from its last daily close before the window opens to its last
              close on or before the window ends. That makes the difference
              column a fair comparison. Volatility, drawdown, and the risk
              ratios live on the Risk screen.
            </p>
          </section>
        </div>
      </SheetContent>
    </Sheet>
  );
}
